import KeycloakWrapper from "@authzsvc/keycloak-js-react";
import Keycloak from "keycloak-js";

import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import App from "./App";
import * as cfg from "./config";
import * as serviceWorker from "./serviceWorker";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <BrowserRouter>
      <KeycloakWrapper
        keycloak={
          new Keycloak({
            url: cfg.keycloakUrl,
            realm: cfg.keycloakRealm,
            clientId: cfg.keycloakClientId,
          })
        }
        refresh={true}
        keycloakParams={{
          onLoad: "login-required",
          promiseType: "native",
          flow: "standard",
        }}
      >
        <App />
      </KeycloakWrapper>
    </BrowserRouter>
  </Provider>
);

serviceWorker.unregister();
